import { Http, Headers } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
var LoginService = (function () {
    function LoginService(http) {
        this.http = http;
        this.apiUrl = environment.apiUrl;
    }
    LoginService.prototype.sendPost = function (data) {
        var url = this.apiUrl + "api/auth/admin/login";
        var headers = new Headers({ 'Content-Type': 'application/json' });
        var body = JSON.stringify(data);
        return this.http.post(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    return LoginService;
}());
export { LoginService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/login/login.service.ts.pre-build-optimizer.js